'use strict';

// v = 2.0

import dispatcher from '../dispatcher';
import loaderStore from './loader.store';
import History from './history.class';
import {offset, clearElements, moveElements} from '../utils';


let html = document.documentElement;

let mutableContainer;
let popups;

let parser = new DOMParser();



function _handleChange(e) {
  if (!e.content) return;

  clearElements(mutableContainer);
  if (popups) clearElements(popups);

  const newDocument = parser.parseFromString(e.content, 'text/html');
  const newHTML = newDocument.querySelector('html');


  if (!newHTML) {
    window.location = '../404';
    return;
  }


  const newTitle = newDocument.querySelector('title');
  const newMutableContainer = newDocument.querySelector('main');
  if (!newMutableContainer) {
    window.location = '../404';
    return;
  }

  if (!e.historyEmitted) {
    History.push({
      state: {
        title: newTitle.innerText,
        href: e.href,
      },
      title: newTitle.innerText,
      href: e.href,
    });
  } else {
    History.title = newTitle.innerText;
  }

  // dispatcher.dispatch({
  //   type: 'template-complete',
  //   components: {
  //     scrl: {
  //       progress: newMutableContainer.querySelectorAll('scrl-view').length ? 0 : 100
  //     }
  //   }
  // });


  moveElements(newMutableContainer, mutableContainer);

  if (newHTML.classList.contains('footerHidden')) {
    html.classList.add('footerHidden');
  } else {
    html.classList.remove('footerHidden');
  }

  if (popups) {
    const newPopups = newDocument.querySelector('.popups');
    moveElements(newPopups, popups);
  }

  _setPosition();

  setTimeout(() => dispatcher.dispatch({
    type: 'mutate',
    _module: 'template.view'
  }), 0);
}


function _setPosition() {
  let hash = window.location.hash;
  let pos = 0;

  if (hash) {
    if (hash.slice(0, 1) === '#') hash = hash.substring(1);
    let anchor = document.getElementById(hash);

    pos = offset(anchor).top;
  }
  window.scrollTo(0, pos);
}


function _subscribe(e) {
  if ((e.type === 'loaded' || e.type === 'load-animation-play') && e.loaded && e.loadAnimation === 'start-complete') {
    _handleChange(e);
  }
}



function init() {
  mutableContainer = document.querySelector('main');

  if (!mutableContainer) return;

  popups = document.querySelector('.popups');

  History.replace({
    state: {
      title: History.title,
      href: window.location.href
    },
    title: History.title,
    href: window.location.href
  });

  _setPosition();

  loaderStore.eventEmitter.subscribe(_subscribe);
}


export default {
  init: init
}